import React from "react";
import { Table } from "antd";

const riskLevel = (percent) => {
  if (percent === 0) return "No Risk";
  if (percent < 25) return "Low";
  if (percent < 50) return "Medium";
  if (percent < 75) return "Medium-High";
  if (percent < 100) return "High";
  return "Very High";
};

const severityColorMap = {
  "No Risk": "#ffffe0", // very light yellow
  Low: "#ffffb2", // light yellow
  Medium: "#ffeda0", // yellow
  "Medium-High": "#feb24c", // orange
  High: "#fd3d2a", // red
  "Very High": "#7f001b", // dark red
};

const severityTextColor = {
  "Very High": "#fff", // White text for dark background
};

const buildTableData = (hazardData, newData, variables) => {
  const allKeys = Object.keys(newData?.both || newData || {});

  return variables
    .map((hazard) => {
      const matchedKey =
        allKeys.find((key) => key.toLowerCase() === hazard.toLowerCase()) ||
        hazard;

      const base = newData?.both?.[matchedKey] || newData?.[matchedKey];
      const projected =
        hazardData?.both?.[matchedKey] || hazardData?.[matchedKey];

      if (!base || !projected) return null;

      const severity = riskLevel(projected[2]);

      return {
        key: matchedKey,
        hazard,
        baseline: `${base[0]} ${base[1]}`,
        projected: `${projected[0]} ${projected[1]}`,
        baseline_days: `${base[3]} Days`,
        projected_days: `${projected[3]} Days`,
        severity,
      };
    })
    .filter(Boolean);
};

const ProgressBar = (props) => {
  const columns = [
    {
      title: "Hazard",
      dataIndex: "hazard",
      key: "hazard",
    },
    {
      title: "Time Horizon",
      children: [
        {
          title: "2020 Baseline Impact",
          dataIndex: "baseline",
          key: "baseline",
        },
        {
          title: "2020 Baseline Days",
          dataIndex: "baseline_days",
          key: "baseline_days",
        },
        {
          title: `${props.year} Projected Impact`,
          dataIndex: "projected",
          key: "projected",
        },

        {
          title: `${props.year} Projected Days`,
          dataIndex: "projected_days",
          key: "projected_days",
        },
      ],
    },
    {
      title: "Severity",
      dataIndex: "severity",
      key: "severity",
      render: (text) => {
        const bgColor = severityColorMap[text] || "#ffffff";
        const color = severityTextColor[text] || "#000000";
        return {
          props: {
            style: {
              backgroundColor: bgColor,
              color,
              fontWeight: "bold",
              textAlign: "center",
            },
          },
          children: <div>{text}</div>,
        };
      },
    },
  ];

  const allData = buildTableData(props.hazard, props.newdata, props.variable);

  return (
    <Table dataSource={allData} columns={columns} pagination={false} bordered />
  );
};

export default ProgressBar;
